import Vue from "vue";
import VueRouter from "vue-router";

const router = new VueRouter({
  mode: "history",
  routes: [
    // 大屏相关路由
    {
      path: "/screen/:schoolNo",
      name: "screen",
      component: () => import('./views/screen/index.vue')
    },
    {
      path: "/screen1/:schoolNo",
      name: "screen1",
      component: () => import('./views/screen/screen1.vue')
    },
    {
      path: "/screen2/:schoolNo",
      name: "screen2",
      component: () => import('./views/screen/screen2.vue')
    },

    // 微信相关路由
    {
      path: "/wechat/home",
      name: "home",
      component: () => import('./views/wechat/home.vue')
    },
    {
      path: "/wechat/:schoolNo",
      name: "wechat",
      component: () => import('./views/wechat/wechat.vue')
    },
    {
      path: "/wechat1/:schoolNo",
      name: "wechat1",
      component: () => import('./views/wechat/wechat1.vue')
    },
    {
      path: "/wechat1-onLineLetOut/:schoolNo",
      name: "wechat1-onLineLetOut",
      component: () => import('./views/wechat/wechat1-onLineLetOut.vue')
    },
  ]
});
Vue.use(VueRouter);

export default router;
